module.exports = __webpack_public_path__ + "static/media/kmt-logo.f062e3b5.png";